module.exports = __webpack_public_path__ + "202408221624/img/help_gif.ace84738.gif";